import { defTitle } from 'assets/strings';
import FormGenerator from 'components/Form/template/FormGenerator';
import SimplesForm from 'components/modal/template/simplesForm';
import React, { FC, memo, useEffect } from 'react';

const ComponentCreateTaxa: FC<any> = memo((oProps) => {
    useEffect(() => {
        document.title = `${defTitle} - Criar Taxa`;
    });

    return (
        <SimplesForm
            rForm={oProps.rForm}
            handleSubmit={oProps.handleSubmit}
            loading={oProps.loading}
            titleSubmit={'Criar Taxa'}
            titleModal={'Cadastrar Nova Taxa'}
            message="Preencha os campos abaixo para criar uma nova taxa."
        >
            <FormGenerator rForm={oProps.rForm} childs={oProps.inputs} />
        </SimplesForm>
    );
});

export default ComponentCreateTaxa;